import { render } from "./GroupInfo.vue?vue&type=template&id=11ee438a&scoped=true"
import script from "./GroupInfo.vue?vue&type=script&lang=js"
export * from "./GroupInfo.vue?vue&type=script&lang=js"

import "./GroupInfo.vue?vue&type=style&index=0&id=11ee438a&scoped=true&lang=less"

import exportComponent from "/Users/woniu/Desktop/woniu/web-tuiguangzu/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11ee438a"]])

export default __exports__